var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.1094 6.61987H43.5627C45.9314 6.61987 47.8694 8.55787 47.8694 10.9265V41.0732C47.8694 43.4419 45.9314 45.3799 43.5627 45.3799H9.1094C6.74073 45.3799 4.80273 43.4419 4.80273 41.0732V10.9265C4.80273 8.55787 6.74073 6.61987 9.1094 6.61987ZM11.2627 36.7665H22.0294V32.4599H11.2627V36.7665ZM11.2627 28.1532H22.0294V23.8465H11.2627V28.1532ZM11.2627 19.5399H22.0294V15.2332H11.2627V19.5399ZM39.8399 19.043L41.2412 20.4443L35.6856 25.9999L41.2412 31.5555L39.8399 32.9568L34.2843 27.4012L28.7287 32.9568L27.3273 31.5555L32.8829 25.9999L27.3273 20.4443L28.7287 19.043L34.2843 24.5986L39.8399 19.043Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveCustomer);
export default __webpack_public_path__ + "static/media/inactive-customer.9db584ea66838123c811b28737ef838e.svg";
export { ForwardRef as ReactComponent };